<template>
  <f7-page class="main-new-text-order-line">
    <template #fixed>
      <TheNavbar
        class="container-navbar"
        back-btn-enable
        :back-callback="BackToMain"
        :nav-title="`${actualOrder.Serie} / ${actualOrder.Numero}`"
      />
    </template>
    <div class="content-info-line margin-left margin-right pt-3">
      <div class="margin-left text-color-metal-dark">
        {{ $t('common.text') }}
      </div>
      <f7-text-editor
        :resizable="true"
        name="textarea"
        :placeholder="$t('common.writeYourInfo')"
        mode="popover"
        :buttons="['bold', 'italic', 'underline', 'strikeThrough']"
        :value="observations"
        @texteditor:change="(value) => observations = value"
      />
    </div>
    <div class="content-button">
      <f7-button
        class="content-button__save"
        fill
        @click="PressSave"
      >
        {{ $t('common.save') }}
      </f7-button>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useAppOrdersStore } from '@/js/stores/appOrders';

import TheNavbar from '@/components/TheNavbar.vue';
import { Log } from '@/js/common/HIDebuggingSupport';
import { HiNotification } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';

export default {
  name: 'FrmNewTextOrderLine',
  components: {
    TheNavbar,
  },
  props: {
    nuevoPedido: { type: Boolean, default: true },
  },

  data() {
    return {
      observations: null,
      id: 0,
      idTempral: null,
    };
  },
  computed: {
    ...mapState(useAppOrdersStore, ['salesOrderLine']),
    ...mapWritableState(useAppOrdersStore, [
      'actualOrder',
      'estadoLineaEditada',
      'estadoLineaCopiada',
    ]),

  },
  mounted() {
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      if (this.estadoLineaEditada) {
        this.observations = this.salesOrderLine.TextoLinea;
        this.id = this.salesOrderLine.Id;
        this.idTempral = this.salesOrderLine.IdTemporal;
        this.estadoLineaEditada = false;
      }
      if (this.estadoLineaCopiada) {
        this.id = 0;
        this.idTempral = null;
        this.estadoLineaCopiada = false;
      }
    },

    async PressSave() {
      Log(this, this.PressSave.name);
      if (this.observations == null || this.observations === '') {
        HiNotification.Toast(this.$t('commercialization.info.fillInformationToContinue'));
      } else {
        const originalIdTemporal = this.idTempral;
        if (this.id === 0 && this.idTempral == null) {
          this.idTempral = this.actualOrder.lineasPedidoVenta.length;
        }
        const lineaPedidoVenta = {
          TextoLinea: this.observations,
          Id: this.id,
          PaleMixto: 0,
          IdTemporal: this.idTempral,
          TipoLinea: 1,
          LineaEditada: false,
        };
        if (lineaPedidoVenta.Id !== 0) {
          lineaPedidoVenta.LineaEditada = true;
        }
        const actualOrder = { ...this.actualOrder };
        let cambiado = false;
        if (this.actualOrder.lineasPedidoVenta.length > 0) {
          for (let i = 0; i < this.actualOrder.lineasPedidoVenta.length; i += 1) {
            const element = this.actualOrder.lineasPedidoVenta[i];
            if (!cambiado) {
              if (this.id !== 0 && element.Id === this.id) {
                actualOrder.lineasPedidoVenta[i] = lineaPedidoVenta;
                cambiado = true;
              }
              if (this.idTempral != null && element.IdTemporal === this.idTempral) {
                actualOrder.lineasPedidoVenta[i] = lineaPedidoVenta;
                cambiado = true;
              }
              if (this.id === 0 && originalIdTemporal == null) {
                actualOrder.lineasPedidoVenta.push(lineaPedidoVenta);
                cambiado = true;
              }
            }
          }
        } else {
          actualOrder.lineasPedidoVenta.push(lineaPedidoVenta);
        }
        this.actualOrder = actualOrder;
        this.BackToMain();
      }
    },
    async BackToMain() {
      Log(this, this.BackToMain.name);
      f7.views.main.router.navigate('/orderDetail/', {
        ignoreCache: true,
        reloadPrevious: true,
        props: {
          nuevoPedido: this.nuevoPedido,
          navbarBtn: true,
          mostrarBtnNextAdd: true,
          mostrarOnlyBtnAdd: false,
          mostrarToolbar: false,
        },
      });
      await sleep(500);
      f7.views.main.router.back();
    },
  },
};
</script>

<style lang="scss">
.main-new-text-order-line {
  .page-content {
    overflow-y: hidden;
  }
  .container-navbar{
    .navbar-inner {
      .title {
          font-size: 16px;
          font-weight: 400;
      }
    }
  }

  .content-info-line{
    margin-top: 10px;
    height: calc(100% - 96px);
    overflow-y: scroll;
    .text-editor{
      min-height: 200px;
      margin: 0px;
      border-radius: var(--search-input-border-radius);
      border: var(--search-input-border);
    }
  }

  .content-button {
    --f7-button-font-size: 16px;
    position: fixed;
    width: 100%;
    bottom: 0;
    border-top: 1px solid var(--his-silver);
    background-color: #fff;
    height: 70px;
    &__save{
      margin: 10px 20px 10px 20px;
      height: 50px;
      background-color: var(--his-melon)
    }
  }
}
</style>
